/**
 * @generated SignedSource<<fba50b821ab70481508f3e104162edda>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PackageEditTransportFlights_package$data = {
  readonly dates: {
    readonly __id: string;
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly " $fragmentSpreads": FragmentRefs<"PackageEditTransportFlightsRow_packageDate">;
      };
    }>;
    readonly pageInfo: {
      readonly " $fragmentSpreads": FragmentRefs<"Table_pageInfo">;
    };
  };
  readonly " $fragmentSpreads": FragmentRefs<"PackageEditTransportFlightsRow_package">;
  readonly " $fragmentType": "PackageEditTransportFlights_package";
};
export type PackageEditTransportFlights_package$key = {
  readonly " $data"?: PackageEditTransportFlights_package$data;
  readonly " $fragmentSpreads": FragmentRefs<"PackageEditTransportFlights_package">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PackageEditTransportFlights_package",
  "selections": [
    {
      "alias": "dates",
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 2147483647
        }
      ],
      "concreteType": "PackageDateConnection",
      "kind": "LinkedField",
      "name": "tripDates",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "PackageDateEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PackageDate",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "PackageEditTransportFlightsRow_packageDate"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "Table_pageInfo"
            }
          ],
          "storageKey": null
        },
        {
          "kind": "ClientExtension",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "__id",
              "storageKey": null
            }
          ]
        }
      ],
      "storageKey": "tripDates(first:2147483647)"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PackageEditTransportFlightsRow_package"
    }
  ],
  "type": "Package",
  "abstractKey": null
};

(node as any).hash = "4c302027329c73389338ac2bfbd14d1e";

export default node;
